import axios from 'axios'
import router from "@/router";
// 创建可一个新的axios对象
const request = axios.create({
    // baseURL: 'http://192.168.31.165:8082',// 后端的接口地址  ip:port
    // baseURL: 'http://106.14.209.141:8082',// 后端的接口地址  ip:port
    // baseURL: 'http://150.158.32.240:8082/buagents',// 后端的接口地址  ip:port
    //baseURL: 'http://localhost:8082',// 本地测试 - Java后端
    // baseURL: 'http://43.160.236.121:8082/buagents',// 生产环境 - 远程服务器
    baseURL: '/buagents/',// 生产环境 - 走nginx代理

    // timeout: 600000
})
// request 拦截器
// 可以自请求发送前对请求做一些处理
// 比如统一加token，对请求参数统一加密
request.interceptors.request.use(config => {
    config.headers['Content-Type'] = 'application/json;charset=utf-8';
    let user =  JSON.parse(localStorage.getItem("user")||'{}')
    let token = localStorage.getItem('token'); // 从 localStorage 中获取 token
    if (token) {
        config.headers['token'] = token; // 设置请求头
    }
    return config
}, error => {
    console.error('request error: ' + error)//for debug
    return Promise.reject(error)
});

// response 拦截器
// 可以在接口响应后统一处理结果
request.interceptors.response.use(
    response => {
        let res = response.data;
        // 兼容服务端返回的字符串数据
        if (typeof res === 'string') {
            res = res ? JSON.parse(res) : res
        }
        if (res.code==='401'){
            router.push('/login')
        }
        return res;
    },
    error => {
        console.error('response error: ' + error) // for debug
        return Promise.reject(error)
    }
)

export default request